function withTimeout(promise, timeoutMs) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error(`RPC timeout after ${timeoutMs}ms`)), timeoutMs)

        Promise.resolve(promise).then(value => {
            clearTimeout(timer)
            resolve(value)
        }, error => {
            clearTimeout(timer)
            reject(error)
        })
    })
}

export async function selectAvailableRpcProvider({
    rpcUrls,
    expectedChainId,
    createProvider,
    timeoutMs = 5000,
}) {
    const errors = []

    for (const rpcUrl of rpcUrls) {
        const provider = createProvider(rpcUrl)

        try {
            const chainId = await withTimeout(provider.send('eth_chainId', []), timeoutMs)
            if (parseInt(chainId, 16) === Number(expectedChainId)) {
                return provider
            }
            errors.push(`${rpcUrl}: wrong chain ${chainId}`)
        } catch (error) {
            errors.push(`${rpcUrl}: ${error?.message || 'unavailable'}`)
        }
    }

    throw new Error(`No available RPC for chain ${expectedChainId}. ${errors.join('; ')}`)
}
